module.exports = __webpack_public_path__ + "img/inflable-icon.a973fc77.svg";